const useIsNextButtonAvailableForTemplate = () => true;

export default useIsNextButtonAvailableForTemplate;
